/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

import './bootstrap';
import './utils';
import './helpers';

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// require('./components/Example');
// require('./components/CountriesSelect');

import React from 'react'
import CompanyUpdateRequestsHistory from './components/CompanyUpdateRequestsHistory.jsx';
import CompanyUpdateRequests from './components/CompanyUpdateRequests.jsx';
import ProviderUpdate from './components/ProviderUpdate.jsx';
import ReactRenderer from './ReactRenderer.jsx'
import CfdiUploadForm from './components/CfdiUploadForm.jsx';
import CountryStateCity from './components/CountryStateCity.jsx'
import CompleteInformation from './components/CompleteInformation.jsx'
import CompleteInformationMx from './components/CompleteInformationMx.jsx'
import CompleteInformationCol from './components/CompleteInformationCol.jsx'
import CompleteInformationBr from './components/CompleteInformationBr.jsx'
import CompleteInformationOther from './components/CompleteInformationOther.jsx'
import DocumentsPanel from './components/DocumentsPanel.jsx'
import DocumentFields from './components/DocumentFields.jsx'
import DocumentFileItemInternal from './components/DocumentFileItemInternal.jsx'
import DossierDocuments from './components/DossierDocuments.jsx'
import DocumentForm from './components/DocumentForm.jsx'
import PersonalDossierForm from './components/PersonalDossierForm.jsx';
import DossierActions from './components/DossierActions.jsx'
import TransferInternalDossier from './components/TransferInternalDossier.jsx';
import DossierDocumentsStats from './components/DossierDocumentsStats.jsx'
import DocumentView from './components/DocumentView.jsx'
import DocumentFieldView from './components/DocumentFieldView.jsx';
import DossierForm from './components/DossierForm.jsx'
import DossierView from './components/DossierView.jsx'
import DossiersPanel from './components/DossiersPanel.jsx';
import CostCenterPanel from './components/CostCenterPanel.jsx';
import UserProfilePanel from './components/UserProfilePanel.jsx';
import TransferUser from './components/TransferUser.jsx';
import UserProfileForm from './components/UserProfileForm.jsx'
import UserProfileEditForm from './components/UserProfileEditForm.jsx'
import ProviderInvitation from './components/ProviderInvitation.jsx';
import ProviderInternal from './components/ProviderInternal.jsx';
import InternalCompanyIdentifier from './components/InternalCompanyIdentifier.jsx';
import FileComments from './components/FileComments.jsx';
import FrequencyCreator from './components/FrequencyCreator.jsx'
import FileCommentsInternal from './components/FileCommentsInternal.jsx';
import MyProviderDossiersPanel from './components/MyProviderDossiersPanel.jsx';
import ProvidersDossiersPanel from './components/ProvidersDossiersPanel.jsx';
import DashboardDossiersPanel from './components/DashboardDossiersPanel.jsx'
import InternalProvidersDossiersPanel from './components/InternalProvidersDossiersPanel.jsx';
//import ProviderDossierDocumentsPanel from './components/ProviderDossierDocumentsPanel.jsx';
import DossierDocumentsTable from './components/DossierDocumentsTable.jsx';
import DossierPendingDocumentsTable from './components/DossierPendingDocumentsTable.jsx';
// Import removed as indicated by eliminar comment
import Dossier from './components/Dossier.jsx';
import ShareDocuments from './components/ShareDocuments.jsx';
import ReplaceDossier from './components/ReplaceDossier.jsx';
import SuspendRecurrencyModal from './components/SuspendRecurrencyModal.jsx'
import DeletePeriodsModal from './components/DeletePeriodsModal.jsx'
import GeneratePeriodsModal from './components/GeneratePeriodsModal.jsx'
import RemindersForm from './components/RemindersForm.jsx';
 
import FilePanel from './components/FilePanel.jsx';
import DocumentFilesPanel from './components/DocumentFilesPanel.jsx';
import DocumentFilesInternalsPanel from './components/DocumentFilesInternalsPanel.jsx';
import UploadInternalDossiers from './components/UploadInternalDossiers.jsx';
//import UserList from './components/UserList.jsx';
import TopUsersPanel from './components/TopUsersPanel.jsx';
import UsersPanel from './components/UsersPanel.jsx';
import ApiPersonPanel from './components/ApiPersonPanel.jsx';
import ApiPersonTokenList from './components/ApiPersonTokenList.jsx';
import UserForm from './components/UserForm.jsx';
import TransferRights from './components/TransferRights.jsx';
import InvitationPerson from './components/InvitationPerson.jsx';
import ProviderInvitationInformationCard from './components/ProviderInvitationInformationCard.jsx';
import ChangeEmail from './components/ChangeEmail.jsx';
import TransferDossier from './components/TransferDossier.jsx';
import ClientDossierTypesPanel from './components/ClientDossierTypesPanel.jsx';
import ClientInvitationsPanel from './components/ClientInvitationsPanel.jsx';
import ProviderDossierTypesPanel from './components/ProviderDossierTypesPanel.jsx';
import ProviderInvitationsPanel from './components/ProviderInvitationsPanel.jsx';
import ProvidersInvitationsPanel from './components/ProvidersInvitationsPanel.jsx';
import MyProviderInvitationsPanel from './components/MyProviderInvitationsPanel.jsx';
import CostCenterForm from './components/CostCenterForm.jsx';
import CostCenterEditForm from './components/CostCenterEditForm.jsx';
import CostCenterShow from './components/CostCenterShow.jsx';
import ProviderProfile from './components/ProviderProfile.jsx';
import ProviderProfileInternal from './components/ProviderProfileInternal.jsx';
import AccountForm from './components/AccountForm.jsx';
import CfdiDocumentTemplate from './components/CfdiDocumentTemplate.jsx'
import ApprovedDocumentsActions from './components/ApprovedDocumentsActions.jsx'
import PendingDocumentsActions from './components/PendingDocumentsActions.jsx'
import DocumentFieldsCFiscal from './components/DocumentFieldsCFiscal.jsx'
import MyDossiersPanel from './components/MyDossiersPanel.jsx';
import MyDossierForm from './components/MyDossierForm.jsx';
import MyDossierFiles from './components/MyDossierFiles.jsx';
import ProviderPanel from './components/ProviderPanel.jsx';
import MyDossierFilesPanel from './components/MyDossierFilesPanel.jsx';
import MyDossierFileItem from './components/MyDossierFileItem.jsx';
import SharedDossierFilesPanel from './components/SharedDossierFilesPanel.jsx'
import PendingApprovalsPanel from './components/PendingApprovalsPanel.jsx'
import SharedDossiersPanel from './components/SharedDossiersPanel.jsx'
import MySharedDossierFileItem from './components/MySharedDossierFileItem.jsx'
import ProviderInformationCard from './components/ProviderInformationCard.jsx'; 
import ReportsInvitations from './components/ReportsInvitations.jsx';
import ReportsDossierTemplates from './components/ReportsDossierTemplates.jsx';
import ReportsDocumentTemplates from './components/ReportsDocumentTemplates.jsx';
import ReportsProviders from './components/ReportsProviders.jsx';
import ReportsUsers from './components/ReportsUsers.jsx';
import ReportsDocuments from './components/ReportsDocuments.jsx';
import ReportsDossiers from './components/ReportsDossiers.jsx';
import Period from './components/Period.jsx';
import Periods from './components/Periods.jsx'; 
import CreateDocumentFields from './components/CreateDocumentFields.jsx';
import DateFieldValidations from './components/DateFieldsValidation.jsx';
import TextFieldsValidation from './components/TextFieldsValidation.jsx';
import IntegerFieldsValidation from './components/IntegerFieldsValidation.jsx';
import GeneralDocumentForm from './components/GeneralDocumentForm.jsx';
import Doc2SignDocumentForm from './components/Doc2SignDocumentForm.jsx';
import MassiveCfdiForm from './components/MassiveCfdiForm.jsx';
import AutomaticDocumentForm from './components/AutomaticDocumentForm.jsx';
import ReplaceDocumentTemplante from './components/ReplaceDocumentTemplate.jsx';
import DashboardAdmin from './components/DashboardAdmin.jsx'
import DashboardAdminPerson from './components/DashboardAdminPerson.jsx'
import DocumentsActions from './components/DocumentsActions.jsx'
import AdministratorPerson from './components/AdministratorPerson.jsx'
import DeletePersonDocumentsModal from './components/DeletePersonDocumentsModal.jsx'
import DossierDocumentsDeleteTable from './components/DossierDocumentsDeleteTable.jsx'
import PreviewFile from './components/PreviewFile.jsx'
import Pricing from './components/Pricing.jsx'
import ThankYou from './components/ThankYou.jsx'
import SubscriptionInformation from './components/SubscriptionInformation.jsx'
import AdditionalPlans from './components/AdditionalPlans.jsx'
import BillingCycleSwitch from './components/BillingCycleSwitch.jsx'
import PaymentInformation from './components/PaymentInformation.jsx'
import HistoryPayments from './components/HistoryPayments.jsx'
import RejectUpdateRequestModal from './components/RejectUpdateRequestModal.jsx'
import Administrator from './components/Administrator.jsx'
import AuthVenvers from './components/AuthVenvers.jsx';
import VenversProviders from './components/VenversProviders.jsx'
import VenversSyncSettings from './components/VenversSyncSettings.jsx'
import AdministratorUsers from './components/AdministratorUsers.jsx'
import AdministratorCollaborators from './components/AdministratorCollaborators.jsx'
import AdministratorAutomatedReports from './components/AdministratorAutomatedReports.jsx'
import AdministratorInstances from './components/AdministratorInstances.jsx'
import RecycleBinTable from './components/RecycleBinTable.jsx'
import ProviderRecycleBinModal from './components/ProviderRecycleBinModal.jsx'
import RecycleLogModal from './components/RecycleLogModal.jsx'
import Developers from './components/Developers.jsx'
import WebhookDocs from './components/WebhookDocs.jsx'
import LaravelLogViewer from './components/LaravelLogViewer.jsx'
import DeveloperApi from './components/DeveloperApi.jsx'
import ApiGoogleVision from './components/ApiGoogleVision.jsx'
import MassiveDossierReplace from './components/MassiveDossierReplace.jsx'
import AdminRegimen from './components/AdminRegimen.jsx'
import AdminTemplateUploadsReport from './components/AdminTemplateUploadsReport.jsx'
import AdministratorLogs from './components/AdministratorLogs.jsx'

const components = [
  {
    name: "AdministratorLogs",
    component: <AdministratorLogs />
  },
  {
    name: "AdminRegimen",
    component: <AdminRegimen />
  },
  {
    name: "AdminTemplateUploadsReport",
    component: <AdminTemplateUploadsReport />
  },
  {
    name: "MassiveDossierReplace",
    component: <MassiveDossierReplace />
  },
  {
    name: "InternalCompanyIdentifier",
    component: <InternalCompanyIdentifier />
  },
    {
    name: "VenversProviders",
    component: <VenversProviders />
  },
    {
    name: "VenversSyncSettings",
    component: <VenversSyncSettings />
  },
  {
  name: "AdministratorUsers",
  component: <AdministratorUsers />
},
  {
    name: "AdministratorCollaborators",
    component: <AdministratorCollaborators />
  },
  {
    name: "AdministratorAutomatedReports",
    component: <AdministratorAutomatedReports />
  },
  {
    name: "AdministratorInstances",
    component: <AdministratorInstances />
  },
  {
    name: "RecycleBinTable",
    component: <RecycleBinTable />
  },
  {
    name: "ProviderRecycleBinModal",
    component: <ProviderRecycleBinModal />
  },
  {
    name: "RecycleLogModal",
    component: <RecycleLogModal />
  },
  {
    name: "WebhookDocs",
    component: <WebhookDocs />
  },
  {
    name: "LaravelLogViewer",
    component: <LaravelLogViewer />
  },
  {
    name: "Developers",
    component: <Developers />
  },
  {
    name: "DeveloperApi",
    component: <DeveloperApi />
  },
  {
    name: "ApiGoogleVision",
    component: <ApiGoogleVision />
  },
  {
    name: "Administrator",
    component: <Administrator />
  },
  {
    name: "AdministratorPerson",
    component: <AdministratorPerson />
  },
  {
    name: "RejectUpdateRequestModal",
    component: <RejectUpdateRequestModal />
  },
  {
    name: "AuthVenvers",
    component: <AuthVenvers />
  },
  {
    name: "CompanyUpdateRequestsHistory",
    component: <CompanyUpdateRequestsHistory />
  },
  {
    name: "CompanyUpdateRequests",
    component: <CompanyUpdateRequests />
  },
  {
    name: "ProviderUpdate",
    component: <ProviderUpdate />
  },
  {
    name: "PreviewFile",
    component: <PreviewFile />,
  },
  {
    name: "DossierDocumentsDeleteTable",
    component: <DossierDocumentsDeleteTable />,
  },
  {
    name: "DeletePersonDocumentsModal",
    component: <DeletePersonDocumentsModal/>,
  },  
  {
    name: "DocumentsActions",
    component: <DocumentsActions/>,
  },
  {
    name: "PaymentInformation",
    component: <PaymentInformation/>,
  },
  {
    name: "HistoryPayments",
    component: <HistoryPayments/>,
  },
  {
    name: "BillingCycleSwitch",
    component: <BillingCycleSwitch/>,
  },
  {
    name: "AdditionalPlans",
    component: <AdditionalPlans/>,
  },
  {
    name: "SubscriptionInformation",
    component: <SubscriptionInformation/>,
  },
  {
    name: "ThankYou",
    component: <ThankYou/>,
  },
  {
    name: "Pricing",
    component: <Pricing/>,
  },
  {
    name: "GeneralDocumentForm",
    component: <GeneralDocumentForm/>,
  },
  {
    name: "DashboardAdmin",
    component: <DashboardAdmin/>,
  },
  {
    name: "DashboardAdminPerson",
    component: <DashboardAdminPerson/>,
  },
  {
    name: "ReplaceDocumentTemplante",
    component: <ReplaceDocumentTemplante/>,
  },
  {
    name: "Doc2SignDocumentForm",
    component: <Doc2SignDocumentForm/>,
  },
  {
    name: "MassiveCfdiForm",
    component: <MassiveCfdiForm/>,
  },
  {
    name: "AutomaticDocumentForm",
    component: <AutomaticDocumentForm/>,
  },
  {
    name: "CfdiUploadForm",
    component: <CfdiUploadForm/>,
  },
  {
    name: "DeletePeriodsModal",
    component: <DeletePeriodsModal/>,
  },
  {
    name: "GeneratePeriodsModal",
    component: <GeneratePeriodsModal/>,
  },
  {
    name: "PendingDocumentsActions",
    component: <PendingDocumentsActions/>,
  },
  {
    name:"SuspendRecurrencyModal",
    component: <SuspendRecurrencyModal/>
  },
  {
    name: "DocumentFieldView",
    component: <DocumentFieldView/>,
  },
  {
    name: "IntegerFieldsValidation",
    component: <IntegerFieldsValidation/>,
  },
  {
    name: "TextFieldsValidation",
    component: <TextFieldsValidation/>,
  },
  {
    name: "DateFieldValidations",
    component: <DateFieldValidations/>,
  },
  {
    name: "Period",
    component: <Period/>,
  },
  {
    name: "Periods",
    component: <Periods/>,
  },
  {
    name: "PersonalDossierForm",
    component: <PersonalDossierForm />,
  },
  {
    name: "TransferInternalDossier",
    component: <TransferInternalDossier />,
  },
  {
    name: "CfdiDocumentTemplate",
    component: <CfdiDocumentTemplate />,
  },
  {
    name: "FrequencyCreator",
    component: <FrequencyCreator />,
  },
  {
    name: "ProviderInformationCard",
    component: <ProviderInformationCard />,
  },
  {
    name: "CreateDocumentFields",
    component: <CreateDocumentFields />,
  },
  {
    name: "CountryStateCity",
    component: <CountryStateCity />,
  },
  {
    name: "ProviderInvitationInformationCard",
    component: <ProviderInvitationInformationCard />,
  },
  {
    name: "InvitationPerson",
    component: <InvitationPerson />,
  },
  {
    name: "CompleteInformation",
    component: <CompleteInformation />,
  },
  {
    name: "CompleteInformationMx",
    component: <CompleteInformationMx />,
  },
  {
    name: "UploadInternalDossiers",
    component: <UploadInternalDossiers />,
  },
  {
    name: "CompleteInformationCol",
    component: <CompleteInformationCol />,
  },
  {
    name: "CompleteInformationBr",
    component: <CompleteInformationBr />,
  },
  {
    name: "CompleteInformationOther",
    component: <CompleteInformationOther />,
  },
  {
    name: "MySharedDossierFileItem",
    component: <MySharedDossierFileItem />,
  },
  {
    name: "ApprovedDocumentsActions",
    component: <ApprovedDocumentsActions />,
  },
  {
    name: "SharedDossiersPanel",
    component: <SharedDossiersPanel />,
  },
  {
    name: "RemindersForm",
    component: <RemindersForm />,
  },
  {
    name: "DocumentFieldsCFiscal",
    component: <DocumentFieldsCFiscal />,
  },
  {
    name: "DocumentsPanel",
    component: <DocumentsPanel />,
  },

  {
    name: "TransferUser",
    component: <TransferUser />,
  },
  {
    name: "DocumentFields",
    component: <DocumentFields />,
  },
  {
    name: "DossierDocuments",
    component: <DossierDocuments />,
  },
  {
    name: "DocumentForm",
    component: <DocumentForm />,
  },
  {
    name: "DocumentView",
    component: <DocumentView />,
  },
  {
    name: "DossierForm",
    component: <DossierForm />,
  },
  {
    name: "DossierView",
    component: <DossierView />,
  },
  {
    name: "DossiersPanel",
    component: <DossiersPanel />,
  },
  {
    name: "CostCenterForm",
    component: <CostCenterForm />,
  },
  {
    name: "CostCenterEditForm",
    component: <CostCenterEditForm />,
  },
  {
    name: "CostCenterShow",
    component: <CostCenterShow />,
  },
  {
    name: "ShareDocuments",
    component: <ShareDocuments />,
  },
  {
    name: "ReplaceDossier",
    component: <ReplaceDossier />,
  },
  {
    name: "SharedDossierFilesPanel",
    component: <SharedDossierFilesPanel />,
  },
  {
    name: "PendingApprovalsPanel",
    component: <PendingApprovalsPanel />,
  },
  {
    name: "CostCenterPanel",
    component: <CostCenterPanel />,
  },
  {
    name: "UserProfilePanel",
    component: <UserProfilePanel />,
  },
  {
    name: "UserProfileForm",
    component: <UserProfileForm />,
  },
  {
    name: "UserProfileEditForm",
    component: <UserProfileEditForm />,
  },
  {
    name: "ProviderInvitation",
    component: <ProviderInvitation />,
  },
  {
    name: "ProviderInternal",
    component: <ProviderInternal />,
  },
  {
    name: "FileComments",
    component: <FileComments />,
  },
  {
    name: "FileCommentsInternal",
    component: <FileCommentsInternal />,
  },
  {
    name: "MyProviderDossiersPanel",
    component: <MyProviderDossiersPanel />,
  },
  {
    name: "ProvidersDossiersPanel",
    component: <ProvidersDossiersPanel />,
  },
  {
    name: "DashboardDossiersPanel",
    component: <DashboardDossiersPanel />,
  },
  
  {
    name: "InternalProvidersDossiersPanel",
    component: <InternalProvidersDossiersPanel />,
  },
  {
    name: "DossierPendingDocumentsTable",
    component: <DossierPendingDocumentsTable />,
  },
  // Component removed as it was commented out in imports
  
  // Component removed as it was commented out in imports
  
  {
    name: "DossierDocumentsTable", // eliminar
    component: <DossierDocumentsTable />,
  },
  {
    name: "Dossier", // eliminar
    component: <Dossier />,
  },
  {
    name: "DossierActions", // eliminar
    component: <DossierActions />,
  }, 
  {
    name: "DossierDocumentsStats", // eliminar
    component: <DossierDocumentsStats />,
  }, 
  // Component removed as its import was removed
  
  {
    name: "FilePanel",
    component: <FilePanel />,
  },
  {
    name: "DocumentFilesPanel",
    component: <DocumentFilesPanel />,
  },
  {
    name: "DocumentFilesInternalsPanel",
    component: <DocumentFilesInternalsPanel />,
  },
 
  {
    name: "TopUsersPanel",
    component: <TopUsersPanel />
  },
  {
    name: "UsersPanel",
    component: <UsersPanel />
  },
  {
    name: "ApiPersonPanel",
    component: <ApiPersonPanel />
  },
  {
    name: "ApiPersonTokenList",
    component: <ApiPersonTokenList />
  },
  {
    name: "UserForm",
    component: <UserForm />
  },
  {
    name: "TransferRights",
    component: <TransferRights />
  },
  {
    name: "ChangeEmail",
    component: <ChangeEmail />
  },
  {
    name: "TransferDossier",
    component: <TransferDossier />
  },
  {
    name: "ClientDossierTypesPanel",
    component: <ClientDossierTypesPanel />
  },
  {
    name: "ClientInvitationsPanel",
    component: <ClientInvitationsPanel />
  },
  {
    name: "ProviderDossierTypesPanel",
    component: <ProviderDossierTypesPanel />
  },
  {
    name: "ProviderInvitationsPanel",
    component: <ProviderInvitationsPanel />
  },
  {
    name: "ProvidersInvitationsPanel",
    component: <ProvidersInvitationsPanel />
  },
  {
    name: "MyProviderInvitationsPanel",
    component: <MyProviderInvitationsPanel />
  },
  {
    name: "ProviderProfile",
    component: <ProviderProfile />
  },
  {
      name:"ProviderProfileInternal",
      component:<ProviderProfileInternal/>
  },
  {
    name:"DocumentFileItemInternal",
    component:<DocumentFileItemInternal/>
  },
  {
    name: "AccountForm",
    component: <AccountForm />
  },
  {
    name: "MyDossiersPanel",
    component: <MyDossiersPanel />
  },
  {
    name: "MyDossierForm",
    component: <MyDossierForm />
  },
  {
    name: "MyDossierFiles",
    component: <MyDossierFiles />
  },
  {
    name: "ProviderPanel",
    component: <ProviderPanel />
  },
  {
    name: "MyDossierFilesPanel",
    component: <MyDossierFilesPanel />
  },
  {
    name: "MyDossierFileItem",
    component: <MyDossierFileItem />
  },
  {
    name: "ReportsInvitations",
    component: <ReportsInvitations />
  },
  {
    name: "ReportsDossierTemplates",
    component: <ReportsDossierTemplates />
  },
  {
    name: "ReportsDocumentTemplates",
    component: <ReportsDocumentTemplates />
  },
  {
    name: "ReportsProviders",
    component: <ReportsProviders />
  },
  {
    name: "ReportsUsers",
    component: <ReportsUsers />
  },
  {
    name: "ReportsDocuments",
    component: <ReportsDocuments />
  },
  {
    name: "ReportsDossiers",
    component: <ReportsDossiers />
  }
]

new ReactRenderer(components).renderAll();

// Montar ProviderUpdate en el update.blade.php
const providerUpdateRoot = document.getElementById('provider-update-root');
if (providerUpdateRoot) {
  const providerId = providerUpdateRoot.getAttribute('data-provider-id');
  import('./components/ProviderUpdate.jsx').then(({ default: ProviderUpdate }) => {
    import('react-dom').then(ReactDOM => {
      ReactDOM.default.render(<ProviderUpdate providerId={providerId} />, providerUpdateRoot);
    });
  });
}
